import { ITransaction } from './../../../models/transaction';

export namespace SplitTransaction.Actions {
  export class GetTransactions {
    public static readonly type = '[SplitTransaction] Get Split Transactions]';
    constructor(public primaryTransactionId: string) {}
  }

  export class GetPrimaryTransaction {
    public static readonly type = '[SplitTransaction] Get Primary Transaction]';
    constructor(public transactionId: string) {}
  }

  export class SetPrimaryTransaction {
    public static readonly type = '[SplitTransaction] Sey Primary Transaction]';
    constructor(public transaction: ITransaction) {}
  }


  export class InsertSplitTransaction {
    public static readonly type = '[SplitTransaction] Insert Split Transaction]';
    constructor(public transaction: ITransaction) {}
  }

  export class DeleteTransaction {
    public static readonly type = '[SplitTransaction] Delete Split Transaction]';
    constructor(public transaction: ITransaction) {}
  }

  export class GetBalances {
    public static readonly type = '[SplitTransaction] Get Balance Transaction]';
    constructor(public primaryTransaction: ITransaction, public splitTransactions: ITransaction[]) {}
  }

  // export class GetBalances {
  //   public static readonly type = '[SplitTransaction] Get Balances]';
  //   constructor(primaryTransaction: ITransaction, splitTransactions: ITransaction[]) {}
  // }


  export class EditTransaction {
    public static readonly type = '[SplitTransaction] Edit Single Transaction]';
    constructor(public transaction: ITransaction) {}
  }

  // export class GetCampaignOrders {
  //   public static readonly type = '[SplitTransaction] Get Campaign Orders';
  //   constructor(public organizationId: string, public campaignId: string) {}
  // }

  // export class DeleteCampaignOrder {
  //   public static readonly type = '[SplitTransaction] Delete Single Campaign Order]';
  //   constructor(public order: ITransaction) {}
  // }
}
